import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/expertise", label: "Expertise" },
  { to: "/methode", label: "Méthode" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location, setOpen]);

  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 bg-white border-b border-[#E6E4DF]">
      <div className="container-x h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
          <img src="/logo-transparent.png" alt="OptiSolaires" className="w-8 h-8 object-contain" />
          <span className="font-semibold text-[17px] text-[#0F1A2A]">OptiSolaires</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[15px] transition-colors ${isActive ? "text-[#0F1A2A] font-medium" : "text-[#6B7280] hover:text-[#0F1A2A]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/contact" data-testid="nav-cta-devis" className="hidden md:inline-flex btn btn-primary !py-2 !px-4 !text-sm">
          Demander un devis
        </Link>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2 text-[#0F1A2A]"
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E6E4DF] bg-white">
          <div className="container-x py-3 flex flex-col">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 text-[15px] border-b border-[#E6E4DF] last:border-0 ${isActive ? "text-[#0F1A2A] font-medium" : "text-[#1F2A3D]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" data-testid="mobile-nav-cta-devis" className="btn btn-primary mt-4 mb-2 justify-center">
              Demander un devis
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
